<script setup lang="ts">
import { OrganizationSelector } from '@rfc/rfc-components-library'
import ProductionLinesTable from '../../../components/ProductionLineComponents/Table/ProductionLinesTable.vue'
import { ADMIN_PRODUCTION_LINE_ROUTES } from '../../../router/routes.js'

const actionsProps = {
    editPermission: {
        href: ADMIN_PRODUCTION_LINE_ROUTES.baseUrl,
        hasPermission: true
    }
}
</script>

<template>
    <ProductionLinesTable :actionsProps="actionsProps">
        <template #create="props">
            <OrganizationSelector
                :label="$t('productionLine.model.organization')"
                :organizationId="props.data?.organization_id"
                @select="props.onChange({ organization_id: $event?.id })" />
        </template>
    </ProductionLinesTable>
</template>
